import React from 'react';
import { TableCell } from '@mui/material';
export default function Cell(_a) {
    var children = _a.children, isHeader = _a.isHeader;
    if (isHeader) {
        return (React.createElement(TableCell, { sx: { fontWeight: '500', color: '#000' } }, children));
    }
    return (React.createElement(TableCell, { sx: { color: '#000' } }, children));
}
